import script from "./rowInfinite.vue?vue&type=script&setup=true&lang=js"
export * from "./rowInfinite.vue?vue&type=script&setup=true&lang=js"

import "./rowInfinite.vue?vue&type=style&index=0&id=19d83ce0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19d83ce0"]])

export default __exports__